module.exports = __webpack_public_path__ + "static/media/ludica.64d26307.jpg";